export const ExperimentNames = {
    UseWarmupData: 'specs.events.ui.UseWarmupData',
    UseWarmupState: 'specs.events.ui.UseWarmupState',
    DisableMembersSiteCreation: 'specs.events.ui.DisableMembersSiteCreation',
    SelectEventsManually: 'specs.events.ui.SelectEventsManually',
    UseInfraCurrencyFormatter: 'specs.events.ui.UseInfraCurrencyFormatter',
    RsvpButtonSettings: 'specs.events.ui.RsvpButtonSettings',
    PriceOptionsBM: 'specs.events.ui.PriceOptionsBM',
    TicketPreview: 'specs.events.ui.TicketPreview',
    ReservationWithoutWixFeeEnabled: 'specs.events.ReservationWithoutWixFeeEnabled',
    viewerNoCss: 'specs.events.ui.viewerNoCss',
    CancelReservationInDetailsPage: 'specs.events.ui.CancelReservationInDetailsPage',
    DashboardRedesign: 'specs.events.ui.DashboardRedesign',
    EditTicketPDF: 'specs.events.ui.EditTicketPDF',
    ShowExpiredScreenIncorrectSlug: 'specs.events.ui.showExpiredScreenIncorrectSlug',
};
//# sourceMappingURL=experiments.js.map